import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from '../pages/home/home';
import Bargains from '../pages/bargains/bargains';
import BargainDetails from '../pages/bargain-details/bargain-details';
import Admin from '../pages/admin/admin';
import '../-global-styles/animations.css'
import SignUp from '../pages/sign-up/sign-up';
import LogIn from '../pages/log-in/log-in';
import Profile from '../pages/user-profile/user-profile'
import CompleteSignUp from '../pages/sign-up/complete-sign-up'

const Routes = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={Home}/>
                <Route path="/bargains" component={Bargains}/>
                <Route path="/bargain/:symbol" component={BargainDetails}/>
                <Route path="/admin" component={Admin}/>
                <Route path="/signup" component={SignUp}/>
                <Route path="/login" component={LogIn}/>
                <Route path="/profile" component={Profile}/>
                <Route path="/complete-sign-up" component={CompleteSignUp}/>
            </Switch>
        </BrowserRouter>
    );
}

export default Routes;